const FadeOutContainer = ({ isFadeVisibile, children }) => (
  <div className="relative">
    {!isFadeVisibile && (
      <div className="absolute bottom-0 bg-gradient-to-t from-white to-transparent h-16 w-full"></div>
    )}
    {children}
  </div>
);

export default FadeOutContainer;
